import { jsx } from 'react/jsx-runtime';
import DOMPurify from 'dompurify';

const HTMLRenderer = ({ htmlString }) => {
    const cleanHtmlString = DOMPurify.sanitize(htmlString);
    return (jsx("div", { dangerouslySetInnerHTML: { __html: cleanHtmlString } }));
};

export { HTMLRenderer as default };
